(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initAOS() {
    if (typeof AOS === 'undefined') return;

    AOS.init({
      duration: 900,
      easing: 'ease-out-quart',
      once: true,
      offset: 20,
      anchorPlacement: 'top-bottom',
      disable: reducedMotion.matches,
    });
  }

  function refreshAOS() {
    if (typeof AOS !== 'undefined') AOS.refresh();
  }

  function replayIn(container) {
    if (!container || reducedMotion.matches) return;

    container.querySelectorAll('[data-aos]').forEach((el) => {
      el.classList.remove('aos-animate');
    });

    requestAnimationFrame(() => {
      container.querySelectorAll('[data-aos]').forEach((el) => {
        el.classList.add('aos-animate');
      });
    });
  }

  window.EuroAOS = {
    refresh: refreshAOS,
    replayIn,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAOS);
  } else {
    initAOS();
  }

  window.addEventListener('load', refreshAOS);

  reducedMotion.addEventListener('change', () => {
    if (typeof AOS === 'undefined') return;
    AOS.init({ disable: reducedMotion.matches });
    refreshAOS();
  });

  document.addEventListener('shopify:section:load', refreshAOS);
  document.addEventListener('shopify:section:reorder', refreshAOS);
})();
